import React from 'react';
import { EmailCaptureFormContentfulModel } from 'src/api/models/EmailCaptureForm';
import HubspotArticleEmailCapture from 'app_previous/molecules/Pro/Shared/EmailCaptureForm/HubspotEmailCapture';

const getDynamicEmailCaptureForm = (props: EmailCaptureFormContentfulModel): JSX.Element => {
  return <HubspotArticleEmailCapture {...props} />;
};

export default getDynamicEmailCaptureForm;
